import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import ServiceSidebar from '../components/ServiceSidebar'

function ServiceFinancialReporting() {
    return (
        <>
            <PageHeader title="Financial Reporting & Analysis" />

            <div className="page-service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <ServiceSidebar
                                activeService="/service-financial-reporting"
                                ctaTitle="Get Clear Financial Insights"
                                ctaLabel="Reporting inquiries"
                            />
                        </div>
                        <div className="col-lg-8">
                            <div className="service-single-content">
                                <div className="service-featured-image">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/financial-reporting.jpg`}
                                            alt="Financial Reporting & Analysis"
                                        />
                                    </figure>
                                </div>
                                <div className="service-entry">
                                    <h2 className="text-anime-style-2">
                                        Unlock Insights with Professional
                                        Financial Reporting &amp; Analysis
                                    </h2>
                                    <p className="wow fadeInUp">
                                        In today's data-driven world,
                                        understanding your financial health is
                                        key to making informed decisions. Our
                                        financial reporting and analysis
                                        services deliver clear, actionable
                                        insights for Nigerian businesses and
                                        individuals.
                                    </p>
                                    <div className="service-cta-box text-center wow fadeInUp">
                                        <h3>
                                            Ready for data-driven decision
                                            making?
                                        </h3>
                                        <Link
                                            to="/contact"
                                            className="btn-default btn-highlighted"
                                        >
                                            Request a Quote
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceFinancialReporting
